<template>
  <div class="TriggerDetailsDia">
    <el-dialog
      title="触发详情"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="900px"
      top="3%"
      @close="close"
    >
      <div class="">
        <div class="info_box">
          <p><span>风险串号1：</span>{{ currentRow.imeiOne }}</p>
          <p><span>风险串号2：</span>{{ currentRow.imeiTwo || "--" }}</p>
          <p><span>序列号：</span>{{ currentRow.serialNo || "--" }}</p>
          <p>
            <span>机型：</span>{{ currentRow.machineName || "--" }}
          </p>
          <p><span>触发次数总计：</span>{{ currentRow.triggerCount || "0" }}次</p>
          <p><span>风险简述：</span>{{ currentRow.briefRisks }}</p>
          <p><span>风险详细描述：</span>{{ currentRow.detailedRisks }}</p>
        </div>
        <div>
          <el-form
            ref="searchForm"
            :model="searchForm"
            inline
            size="small"
            label-width="68px"
          >
            <el-form-item label="触发时间">
              <el-date-picker
                v-model="entryTime"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="~"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                clearable
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单来源商家" label-width="100px">
              <el-select
                v-model="searchForm.createCompanyId"
                clearable
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in companySelectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号" label-width="55px">
              <el-input
                v-model="searchForm.orderNo"
                placeholder="请输入订单号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                round
                :loading="searchLoading"
                @click="getTableData(1)"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <GlobalTable
          ref="GlobalTable"
          v-loading="searchLoading"
          :columns="tableColumns"
          :data="tableDataList"
          :maxHeight="400"
          :isIndex="false"
          :currentPage="page.pageNum"
          :total="page.total"
          :pageSize="page.pageSize"
          @handleCurrentChange="getTableData"
        >
          <el-table-column label="触发订单号" slot="orderNo" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.orderNo" class="btn" @click="goDetails(row)">{{
                row.orderNo
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label="询价门店"
            slot="createCompanyName"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.createCompanyName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="触发订单机型"
            slot="machineName"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.machineName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            slot="state"
            label="订单状态"
            align="center"
            width="90px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.state === '00'">待确认</span>
              <span v-else-if="row.state === '01'">已确认</span>
              <span v-else-if="row.state === '02'">待支付</span>
              <span v-else-if="row.state === '03'">已绑码</span>
              <span v-else-if="row.state === '04'">已收货</span>
              <span v-else-if="row.state === '05'">降价收货</span>
              <span v-else-if="row.state === '10'">已取消</span>
              <span v-else-if="row.state === '20'">已作废</span>
              <span v-else-if="row.state === '30'">已退回</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单最高报价"
            slot="maxQuotePrice"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.maxQuotePrice || "无报价" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单成交回收商"
            slot="manualMerchantName"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ row.manualMerchantName || "--" }}
            </template>
          </el-table-column>
        </GlobalTable>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="close">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
    companySelectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      entryTime: [
        moment()
          .day(moment().day() - 29)
          .format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59"),
      ],
      pickerMinDate: null,
      pickerMaxDate: null,
      day30: 29 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day30 ||
              time.getTime() < this.pickerMinDate - this.day30
            );
          }
          return false;
        },
      },
      searchLoading: false,
      searchForm: {
        orderNo: "",
        createCompanyId: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataList: [],
      tableColumns: [
        { slotName: "orderNo" },
        { label: "风险串号/序列号", prop: "imei" },
        { slotName: "createCompanyName" },
        { slotName: "machineName" },
        { slotName: "state" },
        { slotName: "maxQuotePrice" },
        { slotName: "manualMerchantName" },
        { label: "触发时间", prop: "createTime" },
      ],
    };
  },
  created() {
    this.getTableData(1);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getTableData(pageNum) {
      if (pageNum) {
        this.page.pageNum = pageNum;
      }
      let startTime = "";
      let endTime = "";
      if (this.entryTime === null) {
        (startTime = ""), (endTime = "");
      } else {
        (startTime = moment(this.entryTime[0]).format("x")),
          (endTime = moment(this.entryTime[1]).format("x"));
      }
      const baseRequest = {
        ...this.searchForm,
        riskNumberId: this.currentRow.id,
        startTime,
        endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.searchLoading = true;
      _api
        .riskNumberRecordsList(baseRequest)
        .then((res) => {
          if (res.code === 1) {
            this.tableDataList = res.data.records;
            this.page.pageNum = res.data.current;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    // 订单详情
    goDetails(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.TriggerDetailsDia {
  .info_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > p {
      margin-bottom: 10px;
      > span {
        color: #333;
      }
    }
    > p:not(:last-child) {
      width: 280px;
    }
  }
  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #0981ff;
  }
}
</style>
